import { TFunction } from 'i18next'

export const OPERATIONAL_STATUS_KEYS = [
  'WAITING_FOR_YOU',
  'BLOCKED',
  'PAUSED',
  'NEEDS_ATTENTION',
  'SLOW',
  'ON_TRACK',
  'COMPLETED',
  'REJECTED',
] as const
export type StatusPillKey = (typeof OPERATIONAL_STATUS_KEYS)[number]

export const getStatusPillLabel = (pillKey: StatusPillKey, t: TFunction<'requests'>): string =>
  t(`table-column.status-pill.${pillKey}`)

// Plain text can't put the days late beside the chip, so it folds them into the label.
export const getStatusTextLabel = (
  { key, overdueWorkingDays }: { key: StatusPillKey; overdueWorkingDays: number },
  t: TFunction<'requests'>
): string =>
  key === 'SLOW' && overdueWorkingDays > 0
    ? t('table-column.status-pill.SLOW_LATE', { count: overdueWorkingDays })
    : getStatusPillLabel(key, t)
